<template>
    <div class="w1100">
        <div class="logo">WoShuoXia</div>
        <div class="cont">
            <div class="left">
                <div class="tit">请谅解！</div>
                <div class="word">我们似乎找不到您要查找的页面。</div>
                <div class="word2">Code: 404</div>
            </div>
            <div class="right">
                <img width="313" height="428" src="../../static/img/470.gif" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "view470",
  data() {
    return {
      "": ""
    };
  },
   mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#fff");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  created() {
    //this.getArea();
  },
  //方法定义
  methods: {
    getArea() {
      let _this = this;
      _this.common.request("api/area", {}, function(res) {
        if (res.status == 200) {
          _this.$router.push("/");
        }
        console.log(res);
      });
    }
  }
};
</script>

<style scoped lang='less' rel="stylesheet/less">
@import "../assets/css/index.less";

.logo{
 color: #686363;
 margin-top: 113px;
 font-size: 36px;
}
.cont{
  margin-top: 106px;
  display: flex;
  align-items: flex-start;
  margin-left:180px;
  .left{
    .tit{
      color: #101010;
      font-size: 48px;
    }
    .word{
       color: #101010;
      font-size: 28px;
    }
    .word2{
      margin-top: 18px;
       color: #101010;
       font-size: 14px;
    }

  }
  .right{
    margin-left: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/view404.vue